<div class="layout-query">
  <ebw-monorepo-sidebar-header [icon]="'build'" [title]="'map.sidebar.query.my_query'" [isSvg]="false">
    {{'map.sidebar.query.info_section' | translate}}
  </ebw-monorepo-sidebar-header>

  <div class="d-flex flex-column">
    <div class="py-2">
      <button mat-flat-button color="primary" class="w-100 add-layer-btn" (click)="managerQueryGo()">
        <mat-icon>add</mat-icon>
        <span>{{'map.sidebar.query.new_query' | translate}}</span>
      </button>
    </div>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label class="bold">{{'map.sidebar.query.search' | translate}}</mat-label>
      <input matInput type="text" class="form-control" [(ngModel)]="ricerca" (keyup)="filterQuery(ricerca)">
    </mat-form-field>
  </div>

  <div class="list-scroll">
    <div class="row g-0" *ngIf="querys.length == 0">
      <div class="col px-2 py-3">
        {{'common.no_result' | translate}}
      </div>
    </div>

    <div *ngFor="let query of querys; let i = index" class="p-2 list-card">
      <div class="d-flex flex-column">

        <div class="list-card--label" [matTooltip]="query.query_name">
          {{query.query_name}}
        </div>

        <div class="list-card--desc">
          <div [matTooltip]="getTooltipDescription(query)">
            {{ getQueryDescription(query) }}
          </div>
        </div>
      </div>

      <div class="list-card--actions">
        <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="query.user_id === currentUserId">
          <mat-icon>more_vert</mat-icon>
        </button>

        <button mat-icon-button color="accent" (click)="queryExec(query)">
          <mat-icon>play_circle_outline</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item class="w-100" (click)="managerQueryGo(query)">
            <mat-icon class="me-1">edit</mat-icon>
            <span>{{'common.modify' | translate}}</span>
          </button>
          <button mat-menu-item class="w-100" (click)="deleteQuery(query.id,query.query_name)">
            <mat-icon class="me-1" color="warn">delete</mat-icon>
            <span>{{'common.delete' | translate}}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
  <mat-paginator class="paginator" #paginator [length]="rows" [hidePageSize]="true" [pageSize]="limit"
    aria-label="Select page" (page)="changePage($event)" [pageIndex]="pageIndex">
  </mat-paginator>
</div>